import React from "react";
import styles from "./Footer.module.scss";
import { useLanguage } from "../../context/Language/LanguageContext";

const Footer = () => {
  const { currentLanguage } = useLanguage();
  return (
    <div className={styles.footerWrapper}>
      <div className={styles.infoWrapper}>
        <div className={styles.logoAndBook}>
          <svg
            width="255"
            height="55"
            viewBox="0 0 255 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M54.6275 25.765L52.0735 20.4214C51.5228 19.2699 50.3731 18.5184 49.1064 18.4494L49.2992 18.1943C50.0289 17.2221 50.201 15.9672 49.7604 14.8364L47.5851 9.21004C47.2409 8.32058 46.5386 7.60351 45.6644 7.23807L40.3223 5.02477C39.0281 4.48696 37.548 4.77655 36.5497 5.75564L36.0885 6.21072V5.91421C36.0885 4.56968 35.3037 3.32858 34.0853 2.7494L28.9772 0.336133C28.0272 -0.112044 26.9464 -0.112044 25.9964 0.336133L20.8883 2.7494C19.6698 3.32168 18.885 4.56279 18.885 5.91421V6.20382L18.4238 5.75564C17.4256 4.77655 15.9455 4.48696 14.6513 5.02477L9.30916 7.23807C8.42799 7.60351 7.7327 8.32058 7.3885 9.21004L5.2131 14.8364C4.77252 15.9672 4.95151 17.2221 5.67435 18.1943L5.86711 18.4494C4.60042 18.5184 3.45077 19.2699 2.90004 20.4214L0.346004 25.765C-0.122118 26.7372 -0.115235 27.8542 0.366655 28.8264L3.23046 34.6183C3.75366 35.687 4.75876 36.3903 5.9153 36.5351C4.99971 37.5004 4.71745 38.9208 5.17869 40.1688L7.0787 45.2366C7.40226 46.1054 8.04938 46.8018 8.89613 47.1879L14.7545 49.8701C16.0901 50.4769 17.6734 50.1873 18.6992 49.1392L18.8919 48.9392V49.084C18.8919 50.4286 19.6767 51.6697 20.8952 52.2489L26.0032 54.6622C26.4782 54.8828 26.9877 55 27.4902 55C27.9928 55 28.5091 54.8897 28.9772 54.6622L34.0853 52.2489C35.3037 51.6766 36.0885 50.4355 36.0885 49.084V48.9392L36.2813 49.1392C37.307 50.1873 38.8904 50.4769 40.2259 49.8701L46.0843 47.1879C46.9311 46.8018 47.5782 46.1054 47.9017 45.2366L49.8017 40.1688C50.2699 38.9208 49.9807 37.5004 49.0651 36.5351C50.2217 36.3903 51.2199 35.6801 51.75 34.6183L54.6138 28.8264C55.0819 27.8611 55.0888 26.7441 54.6275 25.765ZM38.1469 25.4823L36.3432 23.6551C36.178 23.4828 36.0816 23.2552 36.0816 23.0208V21.0281H42.2017L38.1469 25.4823ZM38.2226 29.2401L42.897 33.9701H36.1367L36.2193 31.7637C36.2262 31.55 36.3088 31.3431 36.4534 31.1845L38.2226 29.2401ZM38.3534 7.60351C38.615 7.34839 38.9936 7.27255 39.331 7.41735L44.673 9.63065C44.9002 9.72718 45.0792 9.91334 45.1687 10.1409L47.3441 15.7672C47.4542 16.0637 47.4129 16.3878 47.2271 16.636L46.1531 18.0702C45.981 18.2977 45.7126 18.4356 45.4303 18.4356H36.0816V9.83061L38.3534 7.60351ZM33.5001 18.4287H31.6826C31.4417 18.4287 31.2145 18.3322 31.0424 18.1598L29.9754 17.0911C29.8033 16.9187 29.7069 16.6912 29.7069 16.4429C29.7069 16.2016 29.8033 15.9672 29.9823 15.8017L33.5001 12.3542V18.4287ZM21.4666 5.90733C21.4666 5.55569 21.6731 5.23851 21.9829 5.08682L27.0909 2.67356C27.3388 2.55634 27.621 2.55634 27.862 2.67356L32.97 5.08682C33.2867 5.23851 33.4863 5.55569 33.4863 5.90733V8.7343L28.158 13.9538C27.8757 14.2365 27.6417 14.5537 27.4696 14.9053C27.2974 14.5606 27.0703 14.2365 26.7811 13.9538L21.4528 8.7343V5.90733H21.4666ZM25.2598 16.4498C25.2598 16.6912 25.1703 16.9256 24.9982 17.098L23.9311 18.1667C23.759 18.3391 23.5318 18.4356 23.2909 18.4356H21.4735V12.3611L24.9913 15.8086C25.1634 15.981 25.2598 16.2085 25.2598 16.4498ZM7.61569 15.7672L9.79106 10.1409C9.88055 9.91334 10.0596 9.72718 10.2867 9.63065L15.6288 7.41735C15.739 7.36908 15.856 7.34839 15.9731 7.34839C16.2071 7.34839 16.4343 7.43803 16.6064 7.61041L18.8781 9.83061V18.4356H9.52946C9.24721 18.4356 8.97185 18.2977 8.80663 18.0702L7.7327 16.636C7.54683 16.3878 7.50554 16.0568 7.61569 15.7672ZM16.8198 25.4823L12.765 21.0212H18.885V23.0139C18.885 23.2552 18.7955 23.4828 18.6234 23.6482L16.8198 25.4823ZM18.5133 31.1845C18.6578 31.3431 18.7405 31.55 18.7473 31.7637L18.83 33.9701H12.0697L16.7441 29.2401L18.5133 31.1845ZM6.34898 33.977C6.00478 33.977 5.69499 33.784 5.53666 33.4737L2.67285 27.6818C2.54894 27.4267 2.54895 27.144 2.66598 26.8889L5.21999 21.5384C5.37145 21.2281 5.68812 21.0212 6.03921 21.0212H8.85483C9.10954 21.0212 9.35046 21.1316 9.52257 21.3177L14.9886 27.3233L8.42801 33.9701H6.34898V33.977ZM18.885 45.2366L16.8473 47.3189C16.5788 47.5878 16.1727 47.6637 15.8285 47.5051L9.97005 44.8229C9.74976 44.7195 9.58455 44.5402 9.50194 44.3196L7.6019 39.2517C7.47799 38.9208 7.56061 38.5484 7.80844 38.2933L9.52257 36.5558H18.8919V45.2366H18.885ZM33.5001 49.084C33.5001 49.4357 33.2936 49.7529 32.9838 49.9046L27.8757 52.3178C27.6279 52.435 27.3457 52.435 27.1047 52.3178L21.9967 49.9046C21.68 49.7529 21.4804 49.4357 21.4804 49.084V46.2985L26.9326 40.7341C27.1598 40.5066 27.3457 40.2515 27.4902 39.9895C27.6417 40.2584 27.8275 40.5066 28.0478 40.7341L33.5001 46.2985V49.084ZM21.4666 42.6027V36.5696H23.6626C23.9105 36.5696 24.1514 36.673 24.3166 36.8523L25.0877 37.6659C25.425 38.0244 25.4181 38.576 25.0739 38.9208L21.4666 42.6027ZM33.5001 42.6027L29.8928 38.9208C29.5486 38.5691 29.5486 38.0175 29.879 37.6659L30.6432 36.8523C30.8153 36.673 31.0562 36.5696 31.304 36.5696H33.5001V42.6027ZM34.5396 29.4401C33.982 30.0469 33.6653 30.8398 33.6309 31.6672L33.5414 33.977H31.2971C30.3402 33.977 29.4178 34.3769 28.7638 35.0733L27.9996 35.8869C27.7931 36.1007 27.621 36.342 27.4833 36.5902C27.3457 36.342 27.1735 36.1076 26.967 35.8869L26.196 35.0733C25.542 34.3769 24.6127 33.977 23.6626 33.977H21.4184L21.3289 31.6672C21.3014 30.8398 20.9778 30.0538 20.4202 29.4401L18.5615 27.3923L20.4615 25.4685C21.1155 24.8066 21.4735 23.9378 21.4735 23.007V21.0144H23.2909C24.2202 21.0144 25.1014 20.6489 25.7623 19.987L26.8293 18.9183C27.1047 18.6425 27.3181 18.3322 27.4833 18.0012C27.6486 18.3391 27.8689 18.6494 28.1442 18.9183L29.2113 19.987C29.8721 20.6489 30.7464 21.0144 31.6826 21.0144H33.5001V23.007C33.5001 23.931 33.8581 24.8066 34.5052 25.4685L36.4052 27.3923L34.5396 29.4401ZM47.3717 39.2586L45.4716 44.3265C45.389 44.554 45.2169 44.7333 45.0035 44.8298L39.1451 47.512C38.8009 47.6705 38.3878 47.5947 38.1262 47.3258L36.0885 45.2435V36.5696H45.4578L47.172 38.3071C47.4129 38.5553 47.4956 38.9277 47.3717 39.2586ZM52.2869 27.675L49.4231 33.4668C49.2717 33.7771 48.955 33.9701 48.6108 33.9701H46.5249L39.9643 27.3233L45.4303 21.3177C45.6024 21.1316 45.8433 21.0212 46.0981 21.0212H48.9137C49.2579 21.0212 49.5815 21.2212 49.7329 21.5384L52.2869 26.882C52.4109 27.1371 52.4109 27.4267 52.2869 27.675Z"
              fill="white"
            />
            <path
              d="M69.9607 28.3285L77.9492 8.50376L77.0372 6.2334H80.0889L88.9894 28.3285H85.9682L83.4209 22.0799H73.6696L71.1223 28.3285H69.9607ZM74.0823 21.006H83.0133L78.5453 9.95595L74.0823 21.006Z"
              fill="white"
            />
            <path
              d="M101.415 6.2334C102.969 6.2334 104.289 6.49417 105.379 7.02085C106.469 7.54754 107.325 8.22251 107.942 9.04066C108.558 9.86392 108.95 10.7741 109.103 11.7712C109.261 12.7734 109.18 13.745 108.869 14.691C108.558 15.637 108.008 16.4909 107.233 17.2477C106.459 18.0045 105.45 18.5618 104.212 18.9198L108.583 28.3285H107.422L103.142 19.1755C102.867 19.2164 102.587 19.247 102.292 19.2726C101.996 19.2931 101.706 19.3033 101.41 19.3033H94.3947V28.3336H91.343V6.23852H101.415V6.2334ZM101.288 18.2295C102.378 18.2295 103.285 17.9636 104.008 17.4266C104.732 16.8897 105.272 16.2148 105.629 15.4069C105.985 14.599 106.163 13.7246 106.163 12.7888C106.163 11.853 105.985 10.9787 105.629 10.1707C105.272 9.36282 104.732 8.68784 104.008 8.15093C103.285 7.61402 102.378 7.34812 101.288 7.34812H94.3998V18.2397H101.288V18.2295Z"
              fill="white"
            />
            <path
              d="M110.193 28.3285L118.182 8.50376L117.27 6.2334H120.322L129.222 28.3285H126.201L123.654 22.0799H113.902L111.355 28.3285H110.193ZM114.31 21.006H123.241L118.773 9.95595L114.31 21.006Z"
              fill="white"
            />
            <path
              d="M131.581 6.2334H140.67C142.137 6.2334 143.396 6.42768 144.445 6.8163C145.495 7.20492 146.33 7.70607 146.962 8.31456C147.594 8.92306 148.022 9.60823 148.251 10.365C148.48 11.1218 148.501 11.8735 148.312 12.6201C148.124 13.3666 147.731 14.062 147.13 14.7012C146.534 15.3455 145.729 15.862 144.725 16.2659C145.963 16.6034 146.962 17.1352 147.731 17.8613C148.495 18.5874 149.025 19.3953 149.321 20.2902C149.616 21.185 149.677 22.1054 149.509 23.0514C149.341 23.9974 148.944 24.8616 148.312 25.6388C147.68 26.4161 146.829 27.0603 145.749 27.5666C144.669 28.0728 143.355 28.3234 141.801 28.3234H131.581V6.2334ZM140.573 15.8926C141.663 15.8926 142.565 15.683 143.278 15.2637C143.992 14.8444 144.532 14.3177 144.899 13.6837C145.265 13.0547 145.449 12.3644 145.449 11.6178C145.449 10.8713 145.265 10.181 144.899 9.552C144.532 8.92305 143.992 8.39636 143.278 7.97194C142.565 7.55264 141.663 7.343 140.573 7.343H134.597V15.8977H140.573V15.8926ZM141.674 27.2547C142.764 27.2547 143.671 27.0041 144.394 26.4979C145.118 25.9916 145.663 25.3576 146.03 24.5854C146.396 23.8184 146.58 22.9901 146.58 22.1054C146.58 21.2208 146.396 20.3976 146.03 19.6254C145.663 18.8584 145.118 18.2192 144.394 17.7181C143.671 17.217 142.764 16.9613 141.674 16.9613H134.597V27.2547H141.674Z"
              fill="white"
            />
            <path
              d="M153.753 28.3285V6.2334H169.45V7.33788H156.805V14.7575H165.802V15.8313H156.805V27.2598H169.45V28.3336H153.753V28.3285Z"
              fill="white"
            />
            <path
              d="M186.527 10.9684L185.585 11.0656C185.585 10.3088 185.417 9.64914 185.08 9.09178C184.744 8.53442 184.296 8.06398 183.73 7.68559C183.165 7.3072 182.518 7.02086 181.794 6.83166C181.071 6.64246 180.332 6.54531 179.578 6.54531C178.656 6.54531 177.815 6.65782 177.061 6.87769C176.307 7.09757 175.66 7.38901 175.125 7.74695C174.59 8.10489 174.183 8.52421 173.897 9.00998C173.612 9.49575 173.475 10.002 173.475 10.5235C173.495 11.4695 173.821 12.2365 174.448 12.8297C175.074 13.4177 175.869 13.9342 176.822 14.3791C177.775 14.8188 178.809 15.2432 179.919 15.6421C181.03 16.0409 182.064 16.5267 183.017 17.0943C183.97 17.6619 184.78 18.3726 185.437 19.2266C186.099 20.0805 186.451 21.1799 186.492 22.5247C186.532 23.3685 186.379 24.1815 186.033 24.9689C185.687 25.7564 185.172 26.4518 184.494 27.0501C183.812 27.6484 182.966 28.129 181.947 28.487C180.928 28.8449 179.761 29.0239 178.442 29.0239C177.54 29.0239 176.654 28.9114 175.782 28.6915C174.911 28.4716 174.142 28.1393 173.47 27.6995C172.797 27.2598 172.257 26.7024 171.849 26.0274C171.442 25.3524 171.238 24.5548 171.238 23.6292L172.119 23.5321C172.119 24.2889 172.293 24.9536 172.639 25.5212C172.986 26.0888 173.439 26.5643 174.01 26.9427C174.58 27.3211 175.217 27.6075 175.93 27.7967C176.644 27.9859 177.377 28.083 178.131 28.083C179.053 28.083 179.894 27.9705 180.648 27.7506C181.402 27.5308 182.049 27.2291 182.584 26.8507C183.119 26.4723 183.532 26.0377 183.827 25.5417C184.123 25.0457 184.265 24.5343 184.265 24.0127C184.265 23.2764 184.082 22.6526 183.715 22.1361C183.348 21.6197 182.859 21.1697 182.253 20.7811C181.646 20.3925 180.959 20.0447 180.195 19.7379C179.43 19.4311 178.641 19.1243 177.836 18.8073C177.031 18.4902 176.236 18.1425 175.462 17.7641C174.687 17.3858 173.994 16.9306 173.383 16.4091C172.777 15.8824 172.277 15.2637 171.89 14.5478C171.503 13.8319 171.289 12.9678 171.243 11.9604C171.223 11.1423 171.381 10.3446 171.717 9.57756C172.053 8.81055 172.563 8.13048 173.24 7.54243C173.923 6.95439 174.769 6.47883 175.788 6.12089C176.807 5.76295 177.973 5.58398 179.293 5.58398C180.215 5.58398 181.106 5.69649 181.967 5.91637C182.828 6.13625 183.598 6.46862 184.28 6.90837C184.963 7.34813 185.508 7.91058 185.916 8.58044C186.318 9.24007 186.527 10.0429 186.527 10.9684Z"
              fill="white"
            />
            <path
              d="M201.526 5.69678C203.202 5.69678 204.705 5.93197 206.025 6.40752C207.344 6.88307 208.491 7.52225 209.453 8.33529C210.416 9.14321 211.211 10.0892 211.828 11.163C212.444 12.2368 212.887 13.3669 213.147 14.5583C213.407 15.7497 213.494 16.9565 213.397 18.1889C213.3 19.4212 213.04 20.6024 212.612 21.7427C212.184 22.8778 211.568 23.9312 210.773 24.8977C209.978 25.8641 209.01 26.6771 207.879 27.3265L211.058 32.3121H208.037L205.49 28.3032C204.293 28.6816 202.973 28.8708 201.526 28.8708C199.534 28.8708 197.787 28.5384 196.289 27.8788C194.791 27.2191 193.543 26.3447 192.544 25.2607C191.546 24.1766 190.802 22.9392 190.313 21.5535C189.819 20.1626 189.574 18.7462 189.574 17.294C189.574 15.8418 189.819 14.4203 190.313 13.0345C190.807 11.6437 191.551 10.4113 192.544 9.32729C193.543 8.24325 194.786 7.36885 196.289 6.70922C197.792 6.04959 199.534 5.69678 201.526 5.69678ZM201.526 6.61207C200.059 6.61207 198.775 6.91886 197.675 7.52736C196.574 8.13586 195.657 8.94379 194.923 9.94091C194.19 10.9431 193.64 12.0834 193.273 13.3669C192.906 14.6504 192.722 15.9543 192.722 17.2838C192.722 18.6081 192.906 19.9172 193.273 21.2006C193.64 22.4841 194.19 23.6244 194.923 24.6266C195.657 25.6289 196.574 26.4317 197.675 27.0402C198.775 27.6487 200.059 27.9555 201.526 27.9555C202.993 27.9555 204.272 27.6487 205.362 27.0402C206.453 26.4317 207.365 25.6237 208.098 24.6266C208.832 23.6295 209.382 22.4841 209.749 21.2006C210.116 19.9172 210.299 18.6133 210.299 17.2838C210.299 15.9594 210.116 14.6555 209.749 13.3669C209.382 12.0834 208.832 10.9431 208.098 9.94091C207.365 8.94379 206.453 8.13586 205.362 7.52736C204.277 6.91375 202.993 6.61207 201.526 6.61207Z"
              fill="white"
            />
            <path
              d="M217.508 20.3715V6.22777H220.56V21.0669C220.56 22.1203 220.738 23.0509 221.095 23.8588C221.451 24.6667 221.946 25.352 222.572 25.9093C223.199 26.4667 223.943 26.886 224.788 27.1723C225.639 27.4587 226.566 27.5967 227.57 27.5967C228.365 27.5558 229.134 27.3871 229.868 27.0905C230.601 26.7939 231.254 26.3747 231.819 25.8275C232.385 25.2804 232.838 24.6054 233.169 23.8077C233.505 23.01 233.674 22.0947 233.674 21.0618V6.22266H234.743V20.3664C234.743 21.6498 234.529 22.8259 234.096 23.8844C233.668 24.948 233.067 25.8531 232.303 26.5996C231.539 27.3462 230.622 27.924 229.552 28.3382C228.482 28.7473 227.32 28.9518 226.062 28.9518C224.992 28.9518 223.943 28.7677 222.919 28.3995C221.895 28.0314 220.972 27.4894 220.167 26.7735C219.363 26.0576 218.715 25.1628 218.231 24.0889C217.747 23.0253 217.508 21.7828 217.508 20.3715Z"
              fill="white"
            />
            <path
              d="M239.303 28.3285V6.2334H255V7.33788H242.355V14.7575H251.352V15.8313H242.355V27.2598H255V28.3336H239.303V28.3285Z"
              fill="white"
            />
            <path
              d="M69.9609 47.7234V36.479H71.5148V40.0584H77.4043V36.479H77.9494V47.7234H77.4043V40.6107H71.5148V47.7234H69.9609Z"
              fill="white"
            />
            <path
              d="M86.1211 36.2085C87.135 36.2085 88.0215 36.3772 88.7755 36.7147C89.5346 37.0522 90.1612 37.4971 90.6656 38.0493C91.1649 38.6016 91.547 39.2305 91.8017 39.9362C92.0565 40.6418 92.1838 41.3679 92.1838 42.1043C92.1838 42.8406 92.0565 43.5667 91.8017 44.2723C91.547 44.978 91.1649 45.6069 90.6656 46.1592C90.1663 46.7114 89.5346 47.1563 88.7755 47.4938C88.0164 47.8313 87.135 48 86.1211 48C85.1073 48 84.2208 47.8313 83.4566 47.4938C82.6924 47.1563 82.0607 46.7114 81.5512 46.1592C81.0417 45.6069 80.6647 44.978 80.4151 44.2723C80.1654 43.5667 80.0381 42.8406 80.0381 42.1043C80.0381 41.3679 80.1654 40.6418 80.4151 39.9362C80.6647 39.2305 81.0468 38.6016 81.5512 38.0493C82.0556 37.4971 82.6924 37.0522 83.4566 36.7147C84.2208 36.3772 85.1073 36.2085 86.1211 36.2085ZM86.1211 36.6738C85.3722 36.6738 84.7201 36.8272 84.1597 37.1391C83.5993 37.4511 83.1306 37.8601 82.7587 38.3663C82.3868 38.8777 82.1065 39.4555 81.918 40.11C81.7295 40.7646 81.6378 41.4293 81.6378 42.0991C81.6378 42.769 81.7295 43.4389 81.918 44.0883C82.1065 44.7428 82.3868 45.3206 82.7587 45.832C83.1306 46.3382 83.5993 46.7523 84.1597 47.0592C84.7201 47.3711 85.3722 47.5245 86.1211 47.5245C86.8701 47.5245 87.5171 47.3711 88.0724 47.0592C88.6277 46.7472 89.0914 46.3382 89.4633 45.832C89.8352 45.3257 90.1154 44.7428 90.3039 44.0883C90.4924 43.4337 90.5841 42.769 90.5841 42.0991C90.5841 41.4293 90.4924 40.7594 90.3039 40.11C90.1154 39.4555 89.8352 38.8777 89.4633 38.3663C89.0914 37.8601 88.6277 37.4511 88.0724 37.1391C87.5171 36.8272 86.865 36.6738 86.1211 36.6738Z"
              fill="white"
            />
            <path
              d="M92.5508 37.0415V36.479H102.424V37.0415H98.2619V47.7234H96.7284V37.0415H92.5508Z"
              fill="white"
            />
            <path
              d="M103.785 47.7234V36.479H111.768V37.0415H105.333V40.8152H109.908V41.3623H105.333V47.1763H111.768V47.7234H103.785Z"
              fill="white"
            />
            <path
              d="M112.97 36.479H114.509V47.1763H120.943V47.7234H112.975V36.479H112.97Z"
              fill="white"
            />
          </svg>
          <button
            onClick={() => {
              window.open("https://www.booking.com/Share-hAUEA1", "_self");
            }}
          >
            {currentLanguage === "en" ? (
              "Book Now"
            ) : currentLanguage === "sq" ? (
              "Rezervoni tani"
            ) : currentLanguage === "sr" ? (
              <>Rezerva</>
            ) : (
              <>Reservieren</>
            )}
          </button>
        </div>
        <div className={styles.navigationAndSocial}>
          <div className={styles.section}>
            <h5>
              {currentLanguage === "en" ? (
                "Navigation"
              ) : currentLanguage === "sq" ? (
                "Navigimi"
              ) : currentLanguage === "sr" ? (
                <>Navigacija</>
              ) : (
                <>Navigation</>
              )}
            </h5>
            <p
              onClick={() => {
                window.open("/", "_self");
              }}
            >
              {currentLanguage === "en" ? (
                "Home"
              ) : currentLanguage === "sq" ? (
                "Ballina"
              ) : currentLanguage === "sr" ? (
                <>Dom</>
              ) : (
                <>Heim</>
              )}
            </p>
            <p
              onClick={() => {
                window.open("/rooms", "_self");
              }}
            >
              {currentLanguage === "en" ? (
                "Rooms"
              ) : currentLanguage === "sq" ? (
                "Dhomat"
              ) : currentLanguage === "sr" ? (
                <>Sobe</>
              ) : (
                <>Räume</>
              )}
            </p>
            <p
              onClick={() => {
                window.open("/gallery", "_self");
              }}
            >
              {currentLanguage === "en" ? (
                "Gallery"
              ) : currentLanguage === "sq" ? (
                "Galeria"
              ) : currentLanguage === "sr" ? (
                <>Galerija</>
              ) : (
                <>Galerie</>
              )}
            </p>
            <p
              onClick={() => {
                window.open("/about", "_self");
              }}
            >
              {currentLanguage === "en" ? (
                "About"
              ) : currentLanguage === "sq" ? (
                "Rreth"
              ) : currentLanguage === "sr" ? (
                <>O nama</>
              ) : (
                <>Über Uns</>
              )}
            </p>
            <p
              onClick={() => {
                window.open("/contact", "_self");
              }}
            >
              {currentLanguage === "en" ? (
                "Contact"
              ) : currentLanguage === "sq" ? (
                "Kontaktoni"
              ) : currentLanguage === "sr" ? (
                <>Kontakt</>
              ) : (
                <>Kontakt</>
              )}
            </p>
          </div>
          <div className={styles.section}>
            <h5>
              {currentLanguage === "en" ? (
                "Social Media"
              ) : currentLanguage === "sq" ? (
                "Mediat sociale"
              ) : currentLanguage === "sr" ? (
                <>Društveni mediji</>
              ) : (
                <>Sozialen Medien</>
              )}
            </h5>
            <p
              onClick={() => {
                window.open("https://www.instagram.com/hotelarabesque/");
              }}
            >
              Instagram
            </p>
            <p
              onClick={() => {
                window.open("https://www.facebook.com/hotelarabesque");
              }}
            >
              Facebook
            </p>
            <p
              onClick={() => {
                window.open("https://www.booking.com/Share-hAUEA1", "_self");
              }}
            >
              {currentLanguage === "en" ? (
                "Booking"
              ) : currentLanguage === "sq" ? (
                "Rezervimi"
              ) : currentLanguage === "sr" ? (
                <>Rezervacija</>
              ) : (
                <>Buchung</>
              )}
            </p>
          </div>
        </div>
      </div>
      <div className={styles.legalInfo}>
        <div>
          <p
            style={{ cursor: "help" }}
            onClick={() => {
              window.open("https://origin3agency.com/");
            }}
          >
            {currentLanguage === "en" ? (
              "Made with ♡ by Origin3Agency"
            ) : currentLanguage === "sq" ? (
              "Bërë me ♡ nga Origin3Agency"
            ) : currentLanguage === "sr" ? (
              <>Napravljeno s ♡ u Origin3Agency</>
            ) : (
              <>Mit Liebe ♡ von Origin3Agency</>
            )}
          </p>
          <p>
            {currentLanguage === "en" ? (
              "All rights reserved to Hotel Arabesque,"
            ) : currentLanguage === "sq" ? (
              "Të gjitha të drejtat e rezervuara për Hotel Arabesque,"
            ) : currentLanguage === "sr" ? (
              <>Sva prava pridržana za Hotel Arabesque,</>
            ) : (
              <>Alle Rechte vorbehalten für Hotel Arabesque,</>
            )}{" "}
            {new Date().getFullYear()}®
          </p>
        </div>
        <div className={styles.termsAndPolicy}>
          <p
            onClick={() => {
              window.open("/termsAndConditions", "_self");
            }}
          >
            {currentLanguage === "en" ? (
              "Terms & Conditions"
            ) : currentLanguage === "sq" ? (
              "Termat & Kushtet"
            ) : currentLanguage === "sr" ? (
              <>Odredbe & Uslovi</>
            ) : (
              <>Bedingungen</>
            )}
          </p>
          <p
            onClick={() => {
              window.open("/privacy", "_self");
            }}
          >
            {currentLanguage === "en" ? (
              "Privacy Policy"
            ) : currentLanguage === "sq" ? (
              "Politika e Privatësisë"
            ) : currentLanguage === "sr" ? (
              <>Politika Privatnosti</>
            ) : (
              <>Datenschutzrichtlinie</>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
